import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Stack
} from "@mui/material";
import SavePanel from "components/savePanel";
import { useEncounter } from "../encounter.provider";
import { useState } from "react";
import { encounter } from "dto/encounter.dto";
import { first, isEmpty, isNil } from "lodash";
import { Typography } from "@mui/material";
import satiLogo from "assets/SatiLogo.svg";

const AbsoluteSavePanel = () => {
    const { activeTab, encounterForm, submitCoder, submitDoctor, impressApp } =
        useEncounter();

    const { handleSubmit, reset } = encounterForm;
    const [openWarningDialog, setOpenWarningDialog] = useState(false);

    const validatePrincipal = (value: encounter) => {
        const principal = first(value.diagnosis.principal);
        if (isEmpty(principal?.term) || isNil(principal)) {
            setOpenWarningDialog(true);
            return false;
        } else {
            return true;
        }
    };

    const onSave = () => {
        const validateError = validatePrincipal(encounterForm.getValues());
        if (validateError) {
            onSubmit();
        }
    };

    const onCancel = () => {
        setOpenWarningDialog(false);
    };

    const onSubmit = () => {
        if (activeTab === "coder") {
            return handleSubmit(submitCoder)();
        } else {
            return handleSubmit(submitDoctor)();
        }
    };

    return (
        <>
            <Stack height={38} spacing={1} padding={1}>
                <Divider />
                <Box display="flex">
                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            paddingY={1}
                            sx={{
                                background: "#06314d",
                                width: 300,
                                borderRadius: 2
                            }}
                        >
                            <Typography
                                noWrap
                                sx={{
                                    color: (theme) => theme.palette.common.white
                                }}
                            >
                                DX Interception By
                            </Typography>
                            <img
                                style={{ width: 12, marginLeft: 12 }}
                                alt="logo"
                                src={satiLogo}
                            />
                        </Box>
                        <Typography whiteSpace={"nowrap"} fontWeight={500}>
                            {impressApp
                                ? `Impress version: ${impressApp.version}`
                                : ``}
                        </Typography>
                    </Stack>
                    <SavePanel onCancel={() => reset()} onSave={onSave} />
                </Box>
            </Stack>
            <Dialog
                fullWidth
                maxWidth="xs"
                open={openWarningDialog}
                onClose={onCancel}
            >
                <DialogTitle>Notify</DialogTitle>
                <Divider />
                <DialogContent>
                    <Typography>
                        Would you like to save even without principal diagnosis?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <SavePanel
                        onCancel={onCancel}
                        onSave={() => {
                            onSubmit();
                            onCancel();
                        }}
                        cancelText="Close"
                        saveText="Confirm"
                    />
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AbsoluteSavePanel;
